import buildQuery from 'common/helpers/buildQuery';
import axios from 'public/helpers/MyAxios';
import Config from 'public/constants/Config';

const service = {
  fetchList: (search) => {
    const qs = buildQuery(search);
    return axios.get(`${Config.baseUrl}/surveys?${qs}`);
  },
  fetchOne: (id, expand = '') => axios.get(`${Config.baseUrl}/surveys/${id}${expand}`),
};

export default service;
